
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/project/infrastructure/power-line",
      function () {
        return require("private-next-pages/project/infrastructure/power-line.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/project/infrastructure/power-line"])
      });
    }
  